import script from "./editUser.vue?vue&type=script&setup=true&lang=js"
export * from "./editUser.vue?vue&type=script&setup=true&lang=js"

import "./editUser.vue?vue&type=style&index=0&id=49b62d7e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b62d7e"]])

export default __exports__